import { useEffect, useState } from "react";
import { read, utils } from "xlsx";
import FormControl from "@mui/material/FormControl";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import activeSuccess from "../Images/activesuccess.png";
import axios from "axios";
import Checkbox from "@mui/material/Checkbox";
import CircularProgress from "@mui/material/CircularProgress";
import Modal from "@mui/material/Modal";
import { TextField } from "@mui/material";
import Papa from "papaparse";
import BaseUrl from "../BaseUrl";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core";
import { Helmet } from "react-helmet";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../Loader";
const useStyles = makeStyles((theme) => ({
  modal: {
    "& .MuiBackdrop-root": {
      backgroundColor: "transparent",
    },
  },
  modalPopupDelete: {
    // Add your modalPopupDelete styles here
  },
  modaltext: {
    // Add your modaltext styles here
  },
  modalsubtext: {
    // Add your modalsubtext styles here
  },
}));
export default function ImportOptionsCopy(props) {
  // Function to trigger file input when the custom button is clicked
  const userDetails = JSON.parse(localStorage.getItem("MailSenderuserDetails"));
  const [csvData, setCsvData] = useState([]);
  const classes = useStyles();
  const [erorMessage, setErrorMessage] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState([]);
  const [csvDataFull, setCsvDataFull] = useState([]);
  const [csvName, setCsvName] = useState("");
  const [uploadStatus, setUploadStatus] = useState(false);
  const [confirm, setConfirm] = useState(true);
  const [loader, setLoader] = useState(false);
  const [folderOpen, setFolderOpen] = useState(false);
  const [selected, setSelected] = useState("Import options");
  const [open7, setOpen7] = useState(false);
  const [nameList, setNameList] = useState("");
  const [listName, setListName] = useState("");
  const [nameListArr, setNameListArr] = useState([]);
  const handleClose = () => setOpen3(false);
  const [open3, setOpen3] = useState(false);
  const history = useHistory();
  const [open5, setOpen5] = useState(false);
  const [showToaster, setShowToaster] = useState(false);
  const [pastedData, setPastedData] = useState([]);
  const typesArr = [
    "Email",
    "First Name",
    "Last Name",
    "Phone Number",
    "Company Name",
    "Website",
    "Do Not Import",
  ];

  function triggerFileInput() {
    setOpen3(false);
    const fileInput = document.createElement("input");
    fileInput.type = "file";
    fileInput.accept = ".csv, .xlsx, .txt";
    fileInput.style.display = "none";

    // Attach an event listener to the file input to handle the file selection
    fileInput.addEventListener("change", handleFileUpload);

    // Trigger a click event on the file input to open the file selection dialog
    fileInput.click();
  }

  // Function to handle file uploads
  const [fileLoader, setFileLoader] = useState(false);
  const filterUniqueEmails = (data,mailIndex) => {
    if(mailIndex!==""){
      const uniqueEmails = new Set();
      return data.filter(item => {
        const email = item[mailIndex];
        if (email && !uniqueEmails.has(email)) {
          uniqueEmails.add(email);
          return true;
        }
        return false;
      });
    }
   
  };
  function handleFileUpload(event) {
    setFileLoader(true);
    console.log("event received", event.target.files);
    const selectedFiles = event.target.files;
    if (selectedFiles.length > 0) {
      setCsvName(selectedFiles[0].name);
      const file = selectedFiles[0];
      // eslint-disable-next-line
      languageEncoding(file).then((fileInfo) => {
        if (fileInfo.encoding === null || fileInfo.encoding !== "UTF-16LE") {
          const reader = new FileReader();
          reader.onload = (e) => {
            const fileContent = e.target.result;
            const workbook = read(fileContent, { type: "binary" });
            const sheetName = workbook.SheetNames[0];
            const sheet = workbook.Sheets[sheetName];
            const jsonData = utils.sheet_to_json(sheet, { header: 1 });
            const filteredArray = jsonData.filter((arr) => arr.length > 0);
            let vikki = [];
            let mailIndex=""
            for (let i = 0; i < filteredArray[0].length; i++) {
              if (
                filteredArray[0][i].toLowerCase().includes("name") &&
                !vikki.some((obj) => obj.name === "First Name")
              ) {
                vikki.push({
                  index: i,
                  name: "First Name",
                });
              } else if (
                (filteredArray[0][i].toLowerCase().includes("contact") ||
                  filteredArray[0][i].toLowerCase().includes("phone")) &&
                !vikki.some((obj) => obj.name === "Phone Number")
              ) {
                vikki.push({
                  index: i,
                  name: "Phone Number",
                });
              } else if (
                (filteredArray[0][i].toLowerCase().includes("mail") ||
                  filteredArray[0][i].toLowerCase().includes("email") ||
                  filteredArray[0][i].toLowerCase().includes("gmail")) &&
                !vikki.some((obj) => obj.name === "Email")
              ) {
                mailIndex=i
                vikki.push({
                  index: i,
                  name: "Email",
                });
              } else if (
                (filteredArray[0][i].toLowerCase().includes("company") ||
                  filteredArray[0][i].toLowerCase().includes("office") ||
                  filteredArray[0][i].toLowerCase().includes("organization")) &&
                !vikki.some((obj) => obj.name === "Company Name")
              ) {
                vikki.push({
                  index: i,
                  name: "Company Name",
                });
              } else if (
                (filteredArray[0][i].toLowerCase().includes("site") ||
                  filteredArray[0][i].toLowerCase().includes("website") ||
                  filteredArray[0][i]
                    .toLowerCase()
                    .includes(
                      "url" ||
                        filteredArray[0][i].toLowerCase().includes("domain")
                    )) &&
                !vikki.some((obj) => obj.name === "Website")
              ) {
                vikki.push({
                  index: i,
                  name: "Website",
                });
              } else {
                vikki.push({
                  index: i,
                  name: "",
                });
              }
            }
            setFileLoader(false);
            setSelectedIndex(vikki);
            const filteredData = filterUniqueEmails(filteredArray,mailIndex);
            setCsvData(mailIndex===""?filteredArray.slice(1):filteredData.slice(1));
            setCsvDataFull(mailIndex===""?filteredArray:filteredData);
          };

          reader.readAsBinaryString(file);
        } else {
          setOpen5(true);
          return;
        }
      });
    }
  }
  function findIndexByName(arr, targetName) {
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].name === targetName) {
        return arr[i].index;
      }
    }
    return -1; // Return -1 if the name is not found
  }
  function sendContactToSave() {
    setLoader(true);
    let fNameidx = findIndexByName(selectedIndex, "First Name");
    let lNameidx = findIndexByName(selectedIndex, "Last Name");
    let mailidx = findIndexByName(selectedIndex, "Email");
    let phoneidx = findIndexByName(selectedIndex, "Phone Number");
    let companyidx = findIndexByName(selectedIndex, "Company Name");
    let websiteidx = findIndexByName(selectedIndex, "Website");
    let nameListData = {
      contact:
        csvData.length === 0
          ? pastedData.map((val) => {
              let single = {
                Name: `${
                  fNameidx === -1
                    ? ""
                    : val[fNameidx] === undefined
                    ? ""
                    : val[fNameidx]
                } ${
                  lNameidx === -1
                    ? ""
                    : val[lNameidx] === undefined
                    ? ""
                    : val[lNameidx]
                }`,
                Email:
                  mailidx === -1
                    ? ""
                    : val[mailidx] === undefined
                    ? ""
                    : val[mailidx],
                Phone: `${
                  phoneidx === -1
                    ? ""
                    : val[phoneidx] === undefined
                    ? ""
                    : val[phoneidx]
                }`,
                FirstName:
                  fNameidx === -1
                    ? ""
                    : val[fNameidx] === undefined
                    ? ""
                    : val[fNameidx],
                LastName:
                  lNameidx === -1
                    ? ""
                    : val[lNameidx] === undefined
                    ? ""
                    : val[lNameidx],
                CompanyName:
                  companyidx === -1
                    ? ""
                    : val[companyidx] === undefined
                    ? ""
                    : val[companyidx],
                Website:
                  websiteidx === -1
                    ? ""
                    : val[websiteidx] === undefined
                    ? ""
                    : val[websiteidx],
                // Subscriber: false,
                Blocked: false,
                // SendingOption: "Unverified",
              };
              return single;
            })
          : csvData.map((val) => {
              let single = {
                Name: `${
                  fNameidx === -1
                    ? ""
                    : val[fNameidx] === undefined
                    ? ""
                    : val[fNameidx]
                } ${
                  lNameidx === -1
                    ? ""
                    : val[lNameidx] === undefined
                    ? ""
                    : val[lNameidx]
                }`,
                Email:
                  mailidx === -1
                    ? ""
                    : val[mailidx] === undefined
                    ? ""
                    : val[mailidx],
                Phone: `${
                  phoneidx === -1
                    ? ""
                    : val[phoneidx] === undefined
                    ? ""
                    : val[phoneidx]
                }`,
                FirstName:
                  fNameidx === -1
                    ? ""
                    : val[fNameidx] === undefined
                    ? ""
                    : val[fNameidx],
                LastName:
                  lNameidx === -1
                    ? ""
                    : val[lNameidx] === undefined
                    ? ""
                    : val[lNameidx],
                CompanyName:
                  companyidx === -1
                    ? ""
                    : val[companyidx] === undefined
                    ? ""
                    : val[companyidx],
                Website:
                  websiteidx === -1
                    ? ""
                    : val[websiteidx] === undefined
                    ? ""
                    : val[websiteidx],
                // Subscriber: false,
                Blocked: false,
                // SendingOption: "Unverified",
              };
              return single;
            }),
      name: nameList,
    };
    axios
      .put(
        `${BaseUrl.baseurl}/email-marketing/contact/add-contact-name-list/${
          userDetails && userDetails.details._id
        }`,
        nameListData,
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((response) => {
        if (response.data.status) {
          setLoader(false);
          // setShowToaster(true)
          // toast.success(response.data.message,{autoClose:true,position:"top-right",duration:3000});
          props.closingFun(false);
          // history.push("/Lists");
        } else {
          setLoader(false);
          setShowToaster(true);
          toast.error(response.data.message, {
            autoClose: true,
            position: "top-right",
            duration: 3000,
          });
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
      })
      .catch((err) => console.log("Error"));
  }

  function findDuplicateNames(array) {
    const encounteredNames = new Set();
    const duplicateNames = new Set();
    const duplicates = [];

    for (const obj of array) {
      // Check if the name is not an empty string
      if (obj.name !== "") {
        if (encounteredNames.has(obj.name)) {
          // Duplicate name found
          duplicateNames.add(obj.name);
        }
        // Add the name to the set
        encounteredNames.add(obj.name);
      }
    }

    // Create an array of objects with duplicate names
    for (const obj of array) {
      if (duplicateNames.has(obj.name) && obj.name !== "") {
        duplicates.push(obj.name);
      }
    }
    let vikki = [...new Set(duplicates)];
    return vikki;
  }
  return (
    <div
      style={
        {
          // paddingLeft: "16px",
          // paddingRight: "16px",
          // width: window.innerWidth / 1.08,
          // height:'89vh',
          // overflowY:'scroll'
        }
      }
    >
      <Helmet>
        <title>Import-options</title>
        <meta name="description" content="Email campaign user all warmups" />
      </Helmet>
      {/* <div>{selected}</div> */}
      <>
        {uploadStatus ? (
          <div
            style={{
              boxShadow:
                "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px",
              padding: "16px",
              borderRadius: "12px",
            }}
          >
            <div className="uploadsccessboxdone">
              <div style={{ display: "flex" }}>
                {" "}
                <img
                  src={activeSuccess}
                  alt=""
                  className="atcivesuccesimgstyle"
                />
                Upload file
              </div>
              <div className="nameoffileuploadcsv">
                {csvName}
                <div
                  onClick={() => {
                    setUploadStatus(false);
                    setConfirm(false);
                    setNameList("");
                  }}
                  className="createnewlistbox"
                >
                  Edit
                </div>
              </div>
            </div>
          </div>
        ) : (
          <>
          {
            fileLoader ? (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "60vh",
                }}
              >
                <Loader />
              </div>
            ):(
              <>
              <div
              style={{ display: "flex", flexDirection: "column", gap: "10px" }}
            >
              <div className="uploadcontactrlisttewxt">
                1. Upload your contacts file
              </div>
              <div className="contactimportintxt">
                Select a file containing your contacts to import.
              </div>
            </div>
            {csvData.length === 0 && pastedData.length === 0 ? (
              <div
                // className="dragdropboxcreat"
                style={{
                  backgroundColor: "#D1DFE9",
                  border: "1px dashed #1C485F",
                  borderRadius: "10px",
                  padding: "12px",
                  marginTop: "12px",
                  cursor: "pointer",
                }}
                onClick={() => {
                  setOpen3(true);
                  setFolderOpen(true);
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "6px",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="64"
                    height="64"
                    viewBox="0 0 64 64"
                    fill="none"
                  >
                    <path
                      d="M24 45.3335V29.3335L18.6667 34.6668"
                      stroke="#1C485F"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M24 29.3335L29.3333 34.6668"
                      stroke="#1C485F"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M58.6667 26.6668V40.0002C58.6667 53.3335 53.3333 58.6668 40 58.6668H24C10.6667 58.6668 5.33333 53.3335 5.33333 40.0002V24.0002C5.33333 10.6668 10.6667 5.3335 24 5.3335H37.3333"
                      stroke="#1C485F"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M58.6667 26.6668H48C40 26.6668 37.3333 24.0002 37.3333 16.0002V5.3335L58.6667 26.6668Z"
                      stroke="#1C485F"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  <div className="dragdropfile">Drag and Drop Your File</div>
                  <div className="selectfiluptext">Select a file to upload</div>
                  <div className="selectclv">
                    Select a .csv, .xlsx or .txt file from your computer.
                  </div>
                </div>
              </div>
            ) : (
              <div
                style={{
                  backgroundColor: "#e9f7e9",
                  borderRadius: "12px",
                  border: "1px solid #53d86a",
                  padding: "12px",
                  margin: "10px 0px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "8px",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="64"
                    height="64"
                    viewBox="0 0 64 64"
                    fill="none"
                  >
                    <g clip-path="url(#clip0_2461_21673)">
                      <path
                        d="M32 64C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64Z"
                        fill="#1C485F"
                      />
                      <path
                        d="M38.7331 63.2451C39.3468 63.1261 39.9568 62.9892 40.5625 62.8344C41.5894 62.5474 42.6013 62.2092 43.5945 61.8211C44.5889 61.4362 45.5634 61.0019 46.5145 60.5198C47.4658 60.0357 48.3923 59.5044 49.2905 58.9278C50.1876 58.351 51.0554 57.7298 51.8905 57.0664C52.7271 56.4021 53.5298 55.6964 54.2958 54.9518C55.0605 54.209 55.7877 53.4285 56.4745 52.6131C57.1619 51.797 57.808 50.9471 58.4105 50.0664C59.0128 49.1873 59.5708 48.2786 60.0825 47.3438C60.5942 46.4076 61.0588 45.4464 61.4745 44.4638C61.8906 43.4809 62.2573 42.4779 62.5731 41.4584C62.8436 40.5659 63.075 39.6619 63.2665 38.7491L44.2531 19.7384C42.6475 18.1257 40.7387 16.8463 38.6367 15.974C36.5347 15.1017 34.2809 14.6537 32.0051 14.6558C29.7273 14.6533 27.4714 15.101 25.3672 15.9733C23.2629 16.8456 21.3519 18.1251 19.7438 19.7384C18.1317 21.347 16.8527 23.2577 15.9801 25.3613C15.1074 27.4648 14.6582 29.7198 14.6582 31.9971C14.6582 34.2745 15.1074 36.5294 15.9801 38.633C16.8527 40.7365 18.1317 42.6472 19.7438 44.2558L38.7331 63.2451Z"
                        fill="#1C485F"
                      />
                      <path
                        d="M32.0027 14.6587C36.4347 14.6587 40.8667 16.352 44.2587 19.7414C45.8708 21.3499 47.1498 23.2607 48.0225 25.3642C48.8951 27.4677 49.3443 29.7227 49.3443 32C49.3443 34.2774 48.8951 36.5324 48.0225 38.6359C47.1498 40.7394 45.8708 42.6501 44.2587 44.2587C42.6501 45.8708 40.7394 47.1498 38.6359 48.0225C36.5324 48.8951 34.2774 49.3443 32 49.3443C29.7227 49.3443 27.4677 48.8951 25.3642 48.0225C23.2607 47.1498 21.3499 45.8708 19.7414 44.2587C18.1293 42.6501 16.8503 40.7394 15.9776 38.6359C15.105 36.5324 14.6558 34.2774 14.6558 32C14.6558 29.7227 15.105 27.4677 15.9776 25.3642C16.8503 23.2607 18.1293 21.3499 19.7414 19.7414C21.3494 18.1281 23.2605 16.8485 25.3647 15.9762C27.469 15.104 29.7248 14.6562 32.0027 14.6587ZM39.896 26.664C39.6436 26.6882 39.4032 26.7834 39.2027 26.9387L29.4587 34.2454L24.944 29.7334C23.9654 28.7147 22.0374 30.64 23.0587 31.6187L28.392 36.952C28.6232 37.1707 28.9229 37.3026 29.2403 37.3255C29.5577 37.3483 29.8732 37.2606 30.1334 37.0774L40.8 29.0774C41.696 28.424 41.144 26.6827 40.0347 26.6667C39.9894 26.6644 39.944 26.6644 39.8987 26.6667L39.896 26.664Z"
                        fill="white"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_2461_21673">
                        <rect width="64" height="64" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                  <div className="fileuploadsuctext">
                    Your file has been uploaded!
                  </div>
                  <div className="addedfilename">{csvName}</div>
                </div>
              </div>
            )}

            </>
            )
          }
           
         
            {csvDataFull.length !== 0 && (
              <>
                <div
                  style={{
                    backgroundColor: "#FFF",
                    borderRadius: "12px",
                    boxShadow:
                      "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px",
                  }}
                >
                  <div
                    style={{
                      padding: "6px 12px",
                      fontFamily: "Source Sans 3",
                      fontSize: "14px",
                      fontStyle: "normal",
                      fontWeight: 700,
                      color: "#4B4B4B",
                      borderTopLeftRadius: "12px",
                      borderTopRightRadius: "12px",
                    }}
                  >
                    Preview some lines of your {csvDataFull.length} data
                  </div>
                  <div
                    style={{
                      padding: "6px 12px",
                      borderBottom: "1px solid #DDD",
                      fontFamily: "Source Sans 3",
                      fontSize: "14px",
                      fontStyle: "normal",
                      fontWeight: 700,
                      color: "#4B4B4B",
                    }}
                  >
                    Select the columns from your file
                  </div>
                  <div
                    style={{
                      overflow: "auto",
                      width: "100%",
                      padding: "10px",
                      minHeight: "250px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        gap: "6px",
                        alignItems: "center",
                      }}
                    >
                      {csvDataFull[0].map((val, index) => {
                        return (
                          <div key={index} style={{ padding: "0px 6px" }}>
                            <div
                              style={{ padding: "10px 0px", color: "#1C485F" }}
                            >
                              {val}
                            </div>
                            <FormControl size="medium" sx={{ width: "20vw" }}>
                              <Select
                                displayEmpty
                                variant="standard"
                                value={selectedIndex[index].name}
                                disableUnderline
                                onChange={(e) => {
                                  console.log(
                                    "onchanged val",
                                    e.target.value,
                                    index
                                  );
                                  if (selectedIndex.length !== 0) {
                                    selectedIndex.map((item, i) => {
                                      if (index === i) {
                                        if (
                                          e.target.value === "Do Not Import"
                                        ) {
                                          item.name = "";
                                        } else {
                                          item.name = e.target.value;
                                        }
                                      }
                                    });
                                  }
                                  setSelectedIndex([...selectedIndex]);
                                }}
                                IconComponent={ArrowDropDownIcon}
                                sx={{
                                  outline: "none",
                                  background:
                                    "var(--background-color, #d1dfe9)",
                                  padding: "10px",
                                  border: "1px solid #1c485f",
                                  borderRadius: "4px",
                                  fontFamily: "Source Sans 3",
                                  fontSize: "14px",
                                  fontWeight: 400,
                                  fontStyle: "normal",
                                  lineHeight: "20px",
                                  color: "var(--color-dark-600, #1c485f)",
                                }}
                              >
                                {typesArr.length !== 0 &&
                                  typesArr.map((val) => {
                                    return (
                                      <MenuItem
                                        sx={{
                                          color:
                                            "var(--color-dark-600, #727272)",
                                          fontFamily: "Source Sans 3",
                                          fontSize: "14px",
                                          fontStyle: "normal",
                                          fontWeight: 400,
                                          lineHeight: "20px",
                                        }}
                                        value={val}
                                      >
                                        {val}
                                      </MenuItem>
                                    );
                                  })}
                              </Select>
                            </FormControl>
                          </div>
                        );
                      })}
                    </div>
                    <div
                      style={{
                        display: "flex",
                        gap: "6px",
                        alignItems: "center",
                      }}
                    >
                      {csvDataFull[0].map((val, idx) => {
                        return (
                          <div style={{ padding: "6px" }} key={idx}>
                            <div style={{ width: "20vw" }}>
                              {csvDataFull[1][idx] ? csvDataFull[1][idx] : "--"}
                            </div>
                            <div>
                              {" "}
                              {csvDataFull.length > 2 && csvDataFull[2][idx]
                                ? csvDataFull[2][idx]
                                : "--"}
                            </div>
                            <div>
                              {" "}
                              {csvDataFull.length > 3 && csvDataFull[3][idx]
                                ? csvDataFull[3][idx]
                                : "--"}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      padding: "8px 12px",
                      justifyContent: "flex-start",
                      backgroundColor: "#F9F9F9",
                      borderBottomLeftRadius: "12px",
                      borderBottomRightRadius: "12px",
                    }}
                  >
                    <div className="cancelconfirmbuttonbox">
                      <div
                        onClick={() => {
                          setCsvData([]);
                          setSelected("Import options");
                          setCsvDataFull([]);
                        }}
                        className="cancelbyutnschedule"
                      >
                        Cancel
                      </div>
                      <div
                        onClick={() => {
                          if (
                            selectedIndex.every((obj) => obj.name.trim() === "")
                          ) {
                            setOpen7(true);
                            setErrorMessage([
                              "Please select the select type for import",
                            ]);
                            setTimeout(() => {
                              setOpen7(false);
                            }, 3000);
                          } else {
                            if (
                              selectedIndex.some(
                                (item) => item.name === "Email"
                              )
                            ) {
                              const duplicateData =
                                findDuplicateNames(selectedIndex);

                              if (duplicateData.length > 0) {
                                console.log(
                                  "Duplicate data found:",
                                  duplicateData
                                );
                                let vig = [];
                                duplicateData.map((val) => {
                                  vig.push(
                                    `Column type ${val} has been selected multiple times. Ensure that it's set for only 1 column.`
                                  );
                                });
                                setOpen7(true);
                                setErrorMessage(vig);
                                setTimeout(() => {
                                  setOpen7(false);
                                }, 3000);
                              } else {
                                setUploadStatus(true);
                              }
                            } else {
                              setOpen7(true);
                              setErrorMessage([
                                "One Coloumn should be Email Mandatory",
                              ]);
                              setTimeout(() => {
                                setOpen7(false);
                              }, 3000);
                            }
                          }
                          console.log("getting sleetced index", selectedIndex);
                        }}
                        className="confirmshcedulepink"
                      >
                        Confirm your file
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </>
        )}
        {uploadStatus && (
          <div
            style={{
              boxShadow:
                "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px",
              display: "flex",
              flexDirection: "column",
              gap: "12px",
              padding: "18px",
              borderRadius: "12px",
              margin: "20px 0px",
            }}
          >
            <div
              style={{
                display: "flex",
                fontFamily: "Source Sans 3",
                fontSize: "14px",
                fontStyle: "normal",
                fontWeight: 700,
                color: "#4B4B4B",
              }}
            >
              {" "}
              {nameList && (
                <img
                  src={activeSuccess}
                  alt=""
                  className="atcivesuccesimgstyle"
                />
              )}
              Create a list
            </div>

            <div>
              {/* <TextField
                    autoComplete="off"
                    onChange={(e)=>{
                    setNameList(e.target.value)
                    }}
                    value={nameList}
                    variant="standard"
                    placeholder="Create a new list"
                      
                  /> */}
              <input
                type="text"
                onChange={(e) => {
                  setNameList(e.target.value);
                }}
                value={nameList}
                placeholder="Create a new list"
                style={{
                  padding: "16px 6px",
                  outline: "none",
                  width: "100%",
                  borderRadius: "6px",
                  border: "1px solid #1C485F",
                }}
              />
            </div>
          </div>
        )}

        {uploadStatus && nameList && (
          <div
            className="confirmimportbox"
            style={{
              boxShadow:
                "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px",
            }}
          >
            <div className="confirmfieldtextlist">
              <div className="confirmboxtext">
                <Checkbox
                  checked={confirm}
                  style={{ color: "#1C485F" }}
                  onChange={(e) => setConfirm(e.target.checked)}
                />
                <span
                  style={{
                    color: " var(--color-dark-900, #393939)",
                    fontFamily: "Source Sans 3",
                    fontSize: "12px",
                    fontStyle: "normal",
                    fontWeight: 400,
                    lineHeight: "16px",
                  }}
                >
                  I confirm that my new import adheres to these conditions:
                </span>
              </div>
              <div className="indisdeboxtextconfirm">
                <div>
                  &bull;My contacts explicitly gave me their permission to send
                  Email (newsletter) or SMS campaigns within the last two years,
                  or had been asked to within the last two years
                </div>
                <div>
                  &bull;These contacts were not borrowed from a third party
                </div>
                <div>&bull;These contacts were not purchased or rented</div>
                <div>
                  We may suspend or cancel any email or SMS campaigns sent to
                  contacts that don't adhere to these conditions at any time.
                </div>
              </div>
            </div>
            {!confirm ? (
              <div className="confirmbuttonschedule">Confirm your import</div>
            ) : (
              <div
                onClick={() => {
                  sendContactToSave();
                }}
                className="confirmshcedulepink"
              >
                {!loader ? (
                  "Confirm your import"
                ) : (
                  <CircularProgress
                    size={20}
                    style={{
                      color: "white",
                      marginLeft: "48px",
                      marginRight: "48px",
                    }}
                  />
                )}
              </div>
            )}
          </div>
        )}
      </>
      <Modal
        open={open3}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div
          className={`${folderOpen ? "modalPopupforSelect" : "modalPopup"}`}
          style={{ width: !folderOpen && window.innerWidth / 1.9 }}
        >
          {folderOpen ? (
            <>
              <div className="insidetextselectbox">
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  Import from file
                  <svg
                    onClick={() => {
                      setOpen3(false);
                    }}
                    style={{
                      float: "rigth",
                      marginTop: "-10px",
                      cursor: "pointer",
                    }}
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z"
                      stroke="black"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M9.17004 14.8299L14.83 9.16992"
                      stroke="black"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M14.83 14.8299L9.17004 9.16992"
                      stroke="black"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>

                <div className="uploadints">
                  To upload your list, use Excel, CSV or TXT files with an email
                  column and up to 100,000 rows.
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  width: "100%",
                }}
              >
                <div
                  style={{ alignItems: "center", display: "flex", gap: "10px" }}
                >
                  <div
                    className="cancelbuttonmodal"
                    onClick={() => {
                      setOpen3(false);
                    }}
                  >
                    Cancel
                  </div>
                  <div
                    className="continuebuttonmodal bg-primary"
                    id="file-upload-button"
                    onClick={triggerFileInput}
                  >
                    Select file
                  </div>
                </div>
              </div>
            </>
          ) : (
            <></>
          )}
        </div>
      </Modal>
      <Modal
        className={classes.modal}
        open={open7}
        onClose={() => {
          setOpen7(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div
          className="modalPopupDelete"
          style={{
            left: "35%",
            gap: "0px",
            padding: "12px",
            top: "5%",
            boxShadow: "8px 8px 10px 8px rgba(141, 141, 141, 0.15)",
          }}
        >
          <div className="modaltext">We found the following errors</div>
          {erorMessage.length !== 0 &&
            erorMessage.map((val) => {
              return (
                <div
                  className="modalsubtext"
                  style={{
                    display: "flex",
                    gap: "10px",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      height: "6px",
                      width: "6px",
                      backgroundColor: "red",
                      borderRadius: "50%",
                    }}
                  ></div>
                  {val}
                </div>
              );
            })}
        </div>
      </Modal>
      <Modal
        open={open5}
        onClose={() => {
          setOpen5(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className="modalPopupDelete">
          <div
            className="modaltext"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "22px",
            }}
          >
            Oops ?
          </div>
          <div className="modalsubtext">
            The file was loaded in the wrong encoding. Supported encodings:
            ASCII, UTF-8, binary, ISO-8859-1.
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "10px",
              width: "100%",
            }}
          >
            <div
              className="continuebuttonmodal"
              onClick={() => {
                setOpen5(false);
              }}
            >
              Got it
            </div>
          </div>
        </div>
      </Modal>
      {showToaster && <ToastContainer />}
    </div>
  );
}
